












































































import Vue from "vue";
import DateInput from "@/components/DateInput.vue";

import store, { MetRiportStore } from "../services/MetRiportStore";
import { MetRiportHeadDefaultProps } from "../models/MetRiportHead";

import { ValidationRules } from "@/models/Validation";
import { MetRiportHeadValidationRules as headrules } from "../models/MetRiportHead";
  
interface Data {
    store: MetRiportStore;
    headRules: ValidationRules;
}

export default Vue.extend<Data, {}, {}, {}>({
    components: {
        DateInput
    },

    async beforeMount() {        
        const metRiportId: number = Number(this.$route.params["metRiportId"]) || 0;

        if (metRiportId > 0) {
            await store.loadMetRiportHead(metRiportId);
        } else {
            this.store.metRiportHead = {...MetRiportHeadDefaultProps};
        }
    },

    data() {
        return {
            store,
            headRules: headrules
        };
    }
});
